<div class="bg-searchbar-container">
    <input [placeholder]="placeholder" [(ngModel)]="value" (input)="input()" (change)="change()" />
    <cb-icon name="search"></cb-icon>
</div>